<div class="p-col-12 p-md-12 p-lg-12 grid_container">
  <app-server-grid [configuration]="serverGridConfiguration"
                   [(request)]="serverRequest">
  </app-server-grid>
</div>
